export default {
	PARTNER : 'ebiz_partner',
	INVOICE : 'ebiz_invoice',
	EXTERNAL: 'ebiz_external_inv',
	EXTERNAL_ENG: 'ebiz_external_inv_eng',
	EXTERNAL_GER: 'ebiz_external_inv_ger',
	EXTERNAL_NAV: 'ebiz_external_inv_nav',
	EXTERNAL_NAV_ENG: 'ebiz_external_inv_nav_eng',
	EXTERNAL_NAV_GER: 'ebiz_external_inv_nav_ger',
	ITEM : 'ebiz_item',
	FINANCIAL_ACCOUNT : 'ebiz_financial_account',
	PARTNER_CONTACT : 'ebiz_partner_contact',
	PROFORMA_OUT : 'ebiz_proforma_out',
	HANDMADE_IN : 'ebiz_handmade_document_in',
	HANDMADE_OUT : 'ebiz_handmade_document_out',
	TRANSFER_ITEM : 'ebiz_transfer',
	TRANSFER_HEADER : 'ebiz_transfer_header',
	BALANCE : 'ebiz_balance',
	UBL21 : '_incoming_invoice_ubl2.1',
	UBL21_PROFORMA : '_incoming_proforma_ubl2.1',
	OTP_FINANCIAL_ACCOUNT: 'OTP_financial_account'
};
